export default "__VITE_ASSET__nzKZ4fOQ__"